import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"position":"absolute","top":"65px","left":"0","right":"0","bottom":"10px","overflow-y":"scroll"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "font-weight-bold ms-1 mb-2" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_app_bar = _resolveComponent("main-app-bar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_main_app_bar, {
        elevation: "2",
        "app-bar-color": "",
        "app-bar-text-color": ""
      }),
      _createVNode(_component_v_main, {
        class: "mainDiv playFairFont",
        style: _normalizeStyle({ 'background-image': 'url(' + _ctx.baseImg + ')' })
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_container, { fluid: "" }, {
              default: _withCtx(() => [
                (_ctx.state === 'CATEGORY')
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      class: "mt-0 mx-auto",
                      align: "center",
                      justify: "center",
                      style: {"width":"70%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleryItems, (item, index) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            key: index,
                            lg: "3",
                            sm: "12",
                            xs: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: "mx-auto",
                                "max-width": "300",
                                hover: "",
                                link: "",
                                onClick: ($event: any) => (_ctx.onGalleryItemClick(item.title,item.categoryFolderName, item.pictureCount))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    style: {"object-fit":"scale-down"},
                                    color: "surface-variant",
                                    class: "mx-auto px-auto d-flex justify-center",
                                    height: "300",
                                    width: "200",
                                    src: item.img
                                  }, null, 8, _hoisted_2),
                                  _createVNode(_component_v_card_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state === 'PICTURES')
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          lg: "2",
                          xs: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              "prepend-icon": "mdi-arrow-left",
                              variant: "text",
                              onClick: _ctx.onBackClick
                            }, {
                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode(" Vissza a galériához ")
                              ])),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state === 'PICTURES')
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 2,
                      class: "mt-0 mx-auto",
                      align: "center",
                      justify: "center",
                      style: {"width":"70%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPictures, (picture, index) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            key: index,
                            lg: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: "mx-auto",
                                "max-width": "300",
                                hover: "",
                                link: "",
                                onClick: ($event: any) => (_ctx.onPictureItemClick(picture, index))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    style: {"object-fit":"scale-down"},
                                    color: "surface-variant",
                                    class: "mx-auto px-auto d-flex justify-center",
                                    height: "300",
                                    width: "200",
                                    src: picture
                                  }, null, 8, _hoisted_4)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_dialog, {
            modelValue: _ctx.pictureDialog,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pictureDialog) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { style: {"background-color":"#ffffff00"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pictureDialog = false)),
                    style: {"color":"ivory"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode(" mdi-close ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_carousel, {
                "hide-delimiters": "",
                modelValue: _ctx.selectedSlide,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSlide) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPictures, (item, i) => {
                    return (_openBlock(), _createBlock(_component_v_carousel_item, {
                      key: i,
                      src: item,
                      "reverse-transition": "fade-transition",
                      transition: "fade-transition"
                    }, null, 8, ["src"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}